import { FC } from 'react';
import styles from './MenuChoiceCustomizations.module.scss';
import Modal from '../Modal';

const ErrorDialog: FC<{ error: string; onCloseClick: () => void; isVisible: boolean }> = ({ error, onCloseClick, isVisible }) => {
  return (
    <Modal buttons={[{ label: 'Close', onClick: onCloseClick }]} title='Error' close={onCloseClick} isVisible={isVisible} btnClose={null}>
      <div className={styles.ff_ErrorContainer}>
        <span>{error}</span>
      </div>
    </Modal>
  );
};

export default ErrorDialog;
